/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetBreakdownReportQueryResponse, GetBreakdownReportPathParams, GetBreakdownReport400, GetBreakdownReport401, GetBreakdownReport403, GetBreakdownReport404, GetBreakdownReport409, GetBreakdownReport500 } from "../../types/equipmentController/GetBreakdownReport.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetBreakdownReportUrl(organizationId: GetBreakdownReportPathParams["organizationId"], reportId: GetBreakdownReportPathParams["reportId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/breakdown-reports/${reportId}` as const }
  return res
}

/**
 * @summary Get breakdown report detail
 * {@link /api/organizations/:organizationId/equipment/breakdown-reports/:reportId}
 */
export async function getBreakdownReport(organizationId: GetBreakdownReportPathParams["organizationId"], reportId: GetBreakdownReportPathParams["reportId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetBreakdownReportQueryResponse, ResponseErrorConfig<GetBreakdownReport400 | GetBreakdownReport401 | GetBreakdownReport403 | GetBreakdownReport404 | GetBreakdownReport409 | GetBreakdownReport500>, unknown>({ method : "GET", url : getGetBreakdownReportUrl(organizationId, reportId).url.toString(), ... requestConfig })
  return res.data
}